import GameInfo, { useGameInfo } from '@/components/features/casino/game-info/rush';
import { getStaticAsset } from '@/utils/staticAsset';
import { useTranslation } from 'next-i18next';
import { RushContent } from './styles';
import useTheme from '@/theme/useTheme';
import { GameInfoImageWrapper } from '@/components/features/casino/game-info/styles';
import Image from 'next/image';
import { Box, Typography } from '@mui/material';

const itemNine = {
  src: getStaticAsset('/assets/images/casino/rush-game/symbols/9.png'),
  width: 30,
  height: 30,
  alt: 'item 9',
};
export default function CrashGameInfo() {
  const { t } = useTranslation();
  const { theme } = useTheme();
  const info = [
    // {
    //   type: 'image',
    //   src: getStaticAsset('/assets/images/casino/rush-info/rush.png'),
    //   width: 114,
    //   height: 160,
    //   alt: 'moon rush',
    // },

    {
      type: 'list',
      title: 'Placing Bet:',
      list: [
        'You can select the betting sizes ranging from 0.20  USDT',
        'Use the drop-down list to select the bet size. The larger the bet, the higher the chance to win a high multiplier!',
        'Click bet to win a symbol, which offers different multipliers. The higher the multiplier, the more points you gain.',
        'Every bet goes to the prize pool, and 50% of it goes to the Jackpot!',
        'When the Prize Pool reaches 12,500 USDT  or more, the game enters the Moon Rush phase and it will display a progress bar.',
        'Bets placed during the Moon Rush will reduce the progress bar. When it reaches 0%, only one winner will be selected for the jackpot!',
      ],
    },

    {
      type: 'image',
      src: getStaticAsset('/assets/images/casino/rush-info/rush-info-bet.png'),
      width: 300 / 1.5,
      height: 76 / 1.5,
      alt: 'bet',
    },
    {
      type: 'list',
      title: 'Rush Referral:',
      list: [
        'Players can invite others via unique link.',
        'If the invited user wins the jackpot, 20% of the House Commission will be awarded to the referrer.',
        <Box key={'user win'}>
          <Typography
            sx={{
              color: (theme) => theme.palette.text.help,
            }}
            component={'span'}
          >
            {'3. '}
          </Typography>
          <span>{t('If invited user wins the')}</span>
          <GameInfoImageWrapper
            sx={{
              width: itemNine.width,
              minWidth: itemNine.width,
              height: itemNine.height,
              mr: 0,
              display: 'inline-flex',
              verticalAlign: '-10px',
            }}
          >
            <Image src={itemNine.src} fill alt={itemNine.alt} />
          </GameInfoImageWrapper>
          <span>
            {t(
              '(Bet Amount - (item multiplier (0.1) x Bet Amount)) * 5% will be awarded to inviter.',
            )}
          </span>
        </Box>,
      ],
    },
    {
      type: 'list',
      title: 'House Commission:',
      list: [
        'House takes 5% from the jackpot win.',
        'Referral rewards will get 20% from the house commission.',
      ],
    },
  ];

  const content = useGameInfo(info);
  const img = {
    type: 'image',
    src: getStaticAsset('/assets/images/casino/rush-info/rush.png'),
    width: 114,
    height: 160,
    alt: 'moon rush',
  };
  return (
    <GameInfo title="Moon Rush Game Description" gameId={'1005'} open={false}>
      <RushContent>
        <GameInfoImageWrapper
          sx={{
            minWidth: img.width,
            width: img.width,
            height: img.height,
            mr: 2,
            mb: 2,
          }}
        >
          <Image src={img.src} fill alt={img.alt} />
        </GameInfoImageWrapper>
        <Box>{content}</Box>
      </RushContent>
    </GameInfo>
  );
}
